export const Logout = () => {
    // Remove the token from local storage
    localStorage.removeItem('token');
    localStorage.removeItem('username');
  
    // Optionally, redirect to the login page
    window.location.href = '/signin'; // Redirect to login page
};